<mat-card class="titleBar filter">
  <div class="all">
      <button mat-flat-button [matMenuTriggerFor]="notification" class="user-button">
         All <mat-icon>keyboard_arrow_down</mat-icon>
        </button>
        <mat-menu class="customPanel" #notification="matMenu">
          <mat-card class="filterOption">
              <div class="fillist">
                  <label>Facility Name</label>
                  <div class="filterlist">                
                    <ng-container >                 
                      <div class="lList"><span class="name" >Green Care</span> </div>   
                      <div class="lList"><span class="name" >Home Care</span> </div>       
                    </ng-container>
                  </div>
              </div>
              <div class="fillist">
                  <label>Saved Filter</label>
                  <div class="filterlist">                
                    <ng-container >                 
                      <div class="lList"><span class="name" >Filter 1</span> </div>   
                      <div class="lList"><span class="name" >Filter 2</span> </div>       
                    </ng-container>
                  </div>
              </div>
          </mat-card>
        </mat-menu>
  </div>
  <div class="quickfilter">
      <mat-form-field appearance="">
          <mat-label>Date</mat-label>
          <input matInput [matDatepicker]="picker">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="">
          <mat-label>Time</mat-label>
          <input matInput>           
        </mat-form-field>
        <mat-form-field appearance="">
          <mat-label>Duration</mat-label>
          <mat-select>
            <mat-option value="one">1 hr</mat-option>
            <mat-option value="two">2 hr</mat-option>
          </mat-select>
        </mat-form-field>
        
        <button style="width: 250px;" mat-flat-button color="primary"  (click)="openAddBlock()" >Add Block</button>
  </div>
</mat-card>

<table class="table" >
  <tr>
      <th>Facility Name</th>
      <th>Surgeon</th>
      <th>Rooms</th>
      <th>Date</th>
      <th>Time</th>
      <th>Duration</th>
      
      <th class="action" >Action</th>
  </tr>
  <tr>
      <td>Green Care</td>
      <td>Matt Mcalpin </td>
      <td><a href="javascript:(void)" (click)="openRoomDetail()" >F1-1</a></td>
      <td>18 Dec, 20</td>
      <td>6:00 AM - 8 AM</td>
      <td> 2 hr</td>      
      <td>
          <button mat-flat-button color="warn" class="scheduleBtn"  >Remove</button>
      </td>
  </tr>

</table>

<app-add-block [ngClass]="{'open': showAddBlock}"  (CloseBlockTime)=getCloseAddBlock($event)></app-add-block>
